import {Component, EventEmitter, Input, OnInit, Output, Renderer2} from '@angular/core';
import {IObservation} from "../../../message-models/observation.interface";
import {ObservationType, ObservationTypeString} from '../../../domain-model/observation.class';
import {IObservationSummary} from '../../../message-models/observation-summary.interface';
import {consts} from '../../../common/modals/consts';
import {IAllowedOperations} from "../../../users/models/userInfo.interface";


// import { trigger, transition, animate, style } from '@angular/animations'
@Component({
  selector: 'app-operative-observations',
  templateUrl: './operative-observations.component.html',
  styleUrls: ['./operative-observations.component.scss']
})
export class OperativeObservationsComponent implements OnInit {
  @Input() observations: IObservationSummary[] = [];
  @Input() companyId: string = consts.emptyGuid;
  @Input() allowedOperations: IAllowedOperations;
  @Input() addButtonText = 'Add';
  @Input() showWarningMessage: boolean = false;
  // @ViewChild("newObservation", { read: ElementRef }) newObservation: ElementRef;
  @Output() createObservationClicked: EventEmitter<IObservation> = new EventEmitter<IObservation>();
  @Output() editObservationClicked: EventEmitter<IObservation> = new EventEmitter<IObservation>();
  @Output() viewObservationClicked: EventEmitter<IObservation> = new EventEmitter<IObservation>();
  addNewObservation: boolean;

  constructor(public renderer: Renderer2) { }

  ngOnInit(): void {

  }


  createObservation(observation?: IObservation) {
      this.createObservationClicked.emit(observation);
    this.addNewObservation = true;
  }

  addNewObservationCancel() {
    this.addNewObservation = false;
  }

  viewObservation(observation?: IObservation) {
    this.viewObservationClicked.emit(observation)
  }
  editObservation(observation?: IObservation) {
    this.editObservationClicked.emit(observation);
  }
}
